






















import Vue from "vue";
import proj4 from "proj4";

export default Vue.extend({
  props: {
    epsgParam: {
      type: Object,
      default: Object,
    },
    epsgKey: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      checkInput: "",
      error: "",
      epsgCheck: false,
      epsgBox: true,
    };
  },
  watch: {
    numberParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    epsgCheck() {
      if (this.epsgCheck === true) {
        this.epsgBox = false;
      }
      if (this.epsgCheck === false) {
        this.epsgBox = true;
      }
      this.errorEvent();
    },
    epsgBox() {
      if (this.epsgBox === true) {
        this.error = "";
        this.checkInput = "";
        this.epsgParam[this.epsgKey] = "";
        this.$emit("epsgConsole", "", this.epsgCheck);
      }
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.checkInput = this.epsgParam[this.epsgKey];
    },
    SendNumber(Argument: string) {
      if (Argument === "") {
        this.error = "値を入力してください。";
        this.epsgParam[this.epsgKey] = "";
        this.$emit("epsgConsole", "", this.epsgCheck);
        return;
      } else {
        const defs = JSON.stringify(proj4.defs("EPSG:" + Argument));
        if (defs === undefined) {
          this.error = "このコードは対応していません";
          this.epsgParam[this.epsgKey] = "";
          return;
        }
      }
      String(JSON.stringify(proj4.defs("EPSG:" + Argument)));
      this.epsgParam[this.epsgKey] = Argument;
      this.error = "";
      const defs = JSON.stringify(proj4.defs("EPSG:" + Argument));
      const a = this.epsgCheck;
      if (defs !== undefined) {
        this.$emit("epsgConsole", defs);
      }
    },
    errorEvent() {
      this.$emit("hasError", this.epsgCheck);
    },
  },
});
